import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import SEO from "../components/SEO";
import apiService from "../services/api";

const PageWrapper = styled.div`
  width: 100%;
  background: #ffffff;

  @media (max-width: 768px) {
    padding: 0px 0px 0px;
  }
`;

const HeroSection1 = styled.section`
  position: relative;
  color: white;
  height: 23vh;
  padding: 80px 0;
  text-align: center;
  display: flex;
  align-items: center;
  overflow: hidden;
  background: linear-gradient(135deg, #ff6720 0%, #ff8c42 100%); /* Desktop gradient */

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 60%;
    height: 100%;
    background: 
      url('https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/Allproduct.jpg')
        center/cover no-repeat;
    clip-path: polygon(15% 0%, 100% 0%, 100% 100%, 0% 100%);
    z-index: 1;
  }

  /* Responsive: Remove gradient, show only image + text */
  @media (max-width: 768px) {
    padding: 60px 0;
    height: 15vh;
    background: transparent;
    background-image: url('https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/Allproduct.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    &::before {
      display: none;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1;
    }

    div.container {
      text-align: center;
      width: 100%;
      padding: 0 20px;
      position: relative;
      z-index: 2;
    }
  }

  div.container {
    max-width: 1300px;
    border-radius: 10px;
    text-align: left;
    display: inline-block;
    margin: 0 auto;
    position: relative;
    z-index: 2;
  }
`;

const HeroTitle1 = styled.h1`
  font-size: 48px;
  font-weight: 900;
  margin-bottom: 20px;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 36px;
  }

  @media (max-width: 480px) {
    font-size: 28px;
  }
`;

const Container = styled.div`
  max-width: 1300px;
  padding: 60px 20px;
  margin: 0 auto;
`;

const PageTitle = styled.h1`
  font-size: 48px;
  font-weight: bold;
  color: #333;
  margin-bottom: 50px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 36px;
  }

  @media (max-width: 480px) {
    font-size: 28px;
  }
`;

const CategoriesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }
`;

const CategoryCard = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: white;
  text-decoration: none;
  color: inherit;
  transition: all 0.3s ease;
  cursor: pointer;
  border-bottom: 1px solid #5c5c5c83;
  // border-radius: 10px;
  padding: 30px 10px 10px 10px;
  min-height: 280px;
  justify-content: space-between;
  position: relative;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    border-color: #ff6720;
  }

  @media (max-width: 480px) {
    padding: 20px 15px;
    min-height: 180px;
  }
`;

const CategoryIcon = styled.div`
  width: 100%;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 480px) {
    height: 120px;
    margin-bottom: 15px;
  }
`;

const ProductCountBadge = styled.span`
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  top: 15px;
  right: 15px;
  color: #333;
  font-size: 18px;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 50px;
  // background: #33333398;

  @media (max-width: 480px) {
    top: 10px;
    right: 10px;
    font-size: 11px;
    padding: 4px 8px;
    // gap: 6px;
  }
`;

const CategoryName = styled.h3`
  font-size: 18px;
  font-weight: 400;
  color: #333;
  margin: 0;
  line-height: 1.4;
  text-align: left;

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

const ParallaxWrapper = styled.div`
  position: relative;
  height: 200vh;
`;

const HeroSection = styled.div`
  position: sticky;
  top: 0;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const HeroBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/bg12.jpg');
  background-size: cover;
  background-position: center;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  color: white;
  max-width: 800px;
  padding: 0 20px;
`;

const HeroSubtitle = styled.p`
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const HeroTitle = styled.h1`
  font-size: 72px;
  font-weight: bold;
  margin: 0;
  text-transform: uppercase;
  line-height: 1.1;
  
  @media (max-width: 768px) {
    font-size: 48px;
  }
`;

const MotivationSection = styled.div`
  position: relative;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  margin-top: -100vh;
  z-index: 10;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/MS382Chainsaw.jpg');
    background-size: cover;
    background-position: center;
    z-index: -1;
  }
`;

const MotivationCard = styled.div`
  background: #ff6720;
  padding: 60px 80px;
  max-width: 900px;
  
  @media (max-width: 768px) {
    padding: 40px 30px;
  }
`;

const MotivationLabel = styled.p`
  color: white;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid white;
  display: inline-block;
`;

const MotivationText = styled.h2`
  color: white;
  font-size: 32px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const Svg1 = styled.div`
svg {
  width: 20px;
  height: 20px;
}
`;

const CategoryView = styled.div`
  // width: fit-content;    
  height: fit-content;
  // background-color: #f5f5f5;
`;

const BottomBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

const AllCategoriesPage = () => {

  const [categoryCounts, setCategoryCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProductCounts = async () => {
      try {
        setLoading(true);
        
        // Single API call to get all counts
        const response = await apiService.getCategoryCounts();
        
        if (response.success) {
          // Map counts by category slug to category id
          const counts = {};
          categories.forEach(category => {
            const slug = category.link.split('/').pop();
            counts[category.id] = response.data[slug] || 0;
          });
          
          setCategoryCounts(counts);
        }
      } catch (error) {
        console.error("Failed to fetch product counts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProductCounts();
  }, []);

  const categories = [
    {
      id: "chainsaws",
      name: "Chainsaws",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/MS382Chainsaw.jpg",
      link: "/collections/chainsaws",
    },
    {
      id: "brushchutters",
      name: "Brushchutters",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/FS250Brushcutter.jpg",
      link: "/collections/brushcutters",
    },
    {
      id: "hedge-trimmers",
      name: "Hedge Trimmers",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/HSE52HedgeTrimmer.jpg",
      link: "/collections/hedge-trimmers",
    },
    {
      id: "pole-pruners",
      name: "Pole Pruners",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/HTA86PolePruners.jpg",
      link: "/collections/outdoor-equipment",
    },
    {
      id: "blowers",
      name: "Blowers",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/BGA86BlowerBattery.jpg",
      link: "/collections/cordless-stick-vacuums",
    },
    {
      id: "kombi-multi-system",
      name: "KombiSystem & MultiSystem",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/KM85RKombiengine.jpg",
      link: "/collections/kombisystem-multisystem",
    },
    {
      id: "power-weeders",
      name: "Power Weeders",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/MH710PowerWeeder.jpg",
      link: "/collections/power-weeders",
    },
    {
      id: "lawn-mowers",
      name: "Lawn Mowers",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/RME235ElectricLawnMower.jpg",
      link: "/collections/lawn-mowers",
    },
    {
      id: "mulching-lawn-mowers",
      name: "Mulching Lawn Mowers",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/Mulchinglawnmowers.jpg",
      link: "/collections/mulching-lawn-mowers",
    },
    {
      id: "mistblowers",
      name: "Mistblowers",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/SR420Mistblower.jpg",
      link: "/collections/mistblowers",
    },
    {
      id: "sprayer",
      name: "Sprayer",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/SG230Sprayer.jpg",
      link: "/collections/sprayer",
    },
    {
      id: "water-pump",
      name: "Water Pump",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/WP300WaterPump.jpg",
      link: "/collections/water-pump",
    },
    {
      id: "vaccum-cleaners",
      name: "Vaccum Cleaners",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/SE62VaccumCleaner.jpg",
      link: "/collections/vaccum-cleaners",
    },
    {
      id: "pressure-washers",
      name: "Pressure Washers",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/RE150ElectricPressureWasher.jpg",
      link: "/collections/pressure-washers",
    },
    {
      id: "earth-augers",
      name: "Earth Augers",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/BT131EarthAuger.jpg",
      link: "/collections/earth-augers",
    },
    {
      id: "sweeping-machines",
      name: "Sweeping Machines",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/KG770SweepingMachines.jpg",
      link: "/collections/sweeping-machines",
    },
    {
      id: "multi-purpose-engines",
      name: "Multi Purpose Engines",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/EHC705SEngines.jpg",
      link: "/collections/multi-purpose-engines",
    },
    {
      id: "compressor",
      name: "Compressor",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/KOA20Compressor.jpg",
      link: "/collections/compressor",
    },
    {
      id: "cutt-off-machines",
      name: "Cut-Off Machines",
      image: "https://r2.fivemanage.com/rTu19oDvgan9lzZXivPBw/TSA230Cutt-offMachines.jpg",
      link: "/collections/cutt-off-machines",
    },
  ];

  return (
  <PageWrapper>
    <SEO
      title="All Product Categories | XPLOD-GROUPS"
      description="Browse all our product categories including chainsaws, blowers, lawn mowers, and more professional power tools."
      canonical="/collections/all-categories"
    />

    <HeroSection1>
      <div className="container">
        <HeroTitle1>Products Categories</HeroTitle1>
        <div style={{width: "80px", backgroundColor: "white", height: "10px", marginTop: "-10px"}}/>
      </div>
    </HeroSection1>
    
    {/* <ParallaxWrapper>
      <HeroSection>
        <HeroBackground />
        <HeroContent>
          <HeroSubtitle>Sustainability Report 2022</HeroSubtitle>
          <HeroTitle>Acting For<br/>Tomorrow</HeroTitle>
        </HeroContent>
      </HeroSection>
      
      <MotivationSection>
        <MotivationCard>
          <MotivationLabel>Our Motivation</MotivationLabel>
          <MotivationText>
            XPLOD is a family-owned business with roots in industry that stretch back nearly 100 years. 
            Everything we do has always been focused on people, nature, and their power to grow. 
            That is what drives us – and what we want to keep driving forward.
          </MotivationText>
        </MotivationCard>
      </MotivationSection>
    </ParallaxWrapper> */}
    
    <Container>
      <PageTitle>All Product Categories</PageTitle>
      
      <CategoriesGrid>
        {categories.map((category) => (
          <CategoryCard key={category.id} to={category.link}>
            <ProductCountBadge>
              <span style={{ marginRight: '8px' }}>
                {loading ? '...' : (categoryCounts[category.id] || 0)}
              </span>
              <Svg1>
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1143_622)">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.99992C0 3.44658 0 2.66658 0.253333 2.04992C0.591667 1.23325 1.24 0.584915 2.05333 0.249915C2.66667 -0.00341794 3.44167 -0.00341797 5.00333 -0.00341797C6.565 -0.00341797 7.33667 -0.00341794 7.95333 0.249915C8.77 0.588249 9.41833 1.23658 9.75333 2.04992C10.0067 2.66325 10.0067 3.43825 10.0067 4.99992C10.0067 6.56158 10.0067 7.33325 9.75333 7.94992C9.415 8.76658 8.76667 9.41492 7.95333 9.74992C7.34 10.0032 6.565 10.0032 5.00333 10.0032C3.44167 10.0032 2.67 10.0032 2.05333 9.74992C1.23884 9.41167 0.591583 8.76441 0.253333 7.94992C0 7.33658 0 6.56158 0 4.99992ZM5 8.33325C4.2 8.33325 3.685 8.33325 3.28333 8.30492C2.90333 8.27992 2.75833 8.23492 2.69 8.20492C2.28212 8.03615 1.95785 7.71248 1.78833 7.30492C1.76 7.23492 1.715 7.09158 1.68833 6.71158C1.66333 6.31658 1.66333 5.79992 1.66333 4.99492C1.66333 4.18992 1.66333 3.67825 1.69167 3.27825C1.71667 2.89825 1.76167 2.75325 1.79 2.68492C1.95915 2.27672 2.28347 1.9524 2.69167 1.78325C2.76167 1.75492 2.905 1.70992 3.285 1.68325C3.67833 1.65658 4.195 1.65658 5 1.65658C5.805 1.65658 6.315 1.65658 6.71667 1.68325C7.09667 1.70992 7.24167 1.75492 7.31 1.78325C7.71833 1.94992 8.04333 2.27658 8.21167 2.68325C8.24 2.75325 8.285 2.89825 8.31167 3.27825C8.33833 3.67325 8.33833 4.18992 8.33833 4.99492C8.33833 5.79992 8.33833 6.30992 8.31 6.71158C8.285 7.09158 8.24 7.23658 8.21167 7.30492C8.04215 7.71248 7.71788 8.03615 7.31 8.20492C7.24 8.23492 7.09667 8.27992 6.71667 8.30492C6.32167 8.33325 5.805 8.33325 5 8.33325Z" fill="#333"/>
                  <path d="M27.5013 20C27.2803 20 27.0683 20.0878 26.912 20.2441C26.7558 20.4004 26.668 20.6123 26.668 20.8333C26.668 21.0543 26.7558 21.2663 26.912 21.4226C27.0683 21.5789 27.2803 21.6667 27.5013 21.6667H39.168C39.389 21.6667 39.6009 21.5789 39.7572 21.4226C39.9135 21.2663 40.0013 21.0543 40.0013 20.8333C40.0013 20.6123 39.9135 20.4004 39.7572 20.2441C39.6009 20.0878 39.389 20 39.168 20H27.5013ZM27.5013 35C27.2803 35 27.0683 35.0878 26.912 35.2441C26.7558 35.4004 26.668 35.6123 26.668 35.8333C26.668 36.0543 26.7558 36.2663 26.912 36.4226C27.0683 36.5789 27.2803 36.6667 27.5013 36.6667H39.168C39.389 36.6667 39.6009 36.5789 39.7572 36.4226C39.9135 36.2663 40.0013 36.0543 40.0013 35.8333C40.0013 35.6123 39.9135 35.4004 39.7572 35.2441C39.6009 35.0878 39.389 35 39.168 35H27.5013Z" fill="#333"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9174 17.0001C11.6641 17.6134 11.6641 18.3901 11.6641 19.9501C11.6641 21.5101 11.6641 22.2834 11.9174 22.9001C12.2557 23.7168 12.9041 24.3651 13.7174 24.7001C14.3307 24.9534 15.1057 24.9534 16.6674 24.9534C18.2207 24.9534 19.0007 24.9534 19.6174 24.7001C20.4341 24.3618 21.0824 23.7134 21.4174 22.9001C21.6707 22.2868 21.6707 21.5101 21.6707 19.9501C21.6707 18.3901 21.6707 17.6168 21.4174 17.0001C21.0791 16.1856 20.4319 15.5384 19.6174 15.2001C19.0041 14.9468 18.2274 14.9468 16.6674 14.9468C15.1141 14.9468 14.3341 14.9468 13.7174 15.2001C12.9007 15.5384 12.2524 16.1868 11.9174 17.0001ZM14.9507 23.2501C15.3457 23.2768 15.8624 23.2784 16.6674 23.2784C17.4674 23.2784 17.9824 23.2784 18.3841 23.2501C18.7641 23.2234 18.9091 23.1801 18.9774 23.1501C19.3853 22.9813 19.7095 22.6577 19.8791 22.2501C19.9074 22.1801 19.9524 22.0368 19.9791 21.6568C20.0057 21.2618 20.0057 20.7451 20.0057 19.9401C20.0057 19.1351 20.0057 18.6234 19.9774 18.2234C19.9524 17.8434 19.9074 17.6984 19.8791 17.6301C19.7099 17.2219 19.3856 16.8976 18.9774 16.7284C18.9074 16.6984 18.7641 16.6551 18.3841 16.6284C17.8123 16.6017 17.2398 16.5922 16.6674 16.6001C15.8674 16.6001 15.3524 16.6018 14.9507 16.6284C14.5707 16.6551 14.4257 16.6984 14.3574 16.7284C13.9495 16.8972 13.6252 17.2209 13.4557 17.6284C13.4274 17.6984 13.3824 17.8434 13.3557 18.2234C13.3291 18.6184 13.3291 19.1351 13.3291 19.9401C13.3291 20.7451 13.3291 21.2551 13.3574 21.6568C13.3824 22.0368 13.4274 22.1818 13.4557 22.2501C13.6241 22.6584 13.9491 22.9834 14.3574 23.1501C14.4274 23.1801 14.5707 23.2234 14.9507 23.2501ZM11.6674 35.0001C11.6674 33.4468 11.6674 32.6668 11.9207 32.0501C12.2591 31.2334 12.9074 30.5851 13.7207 30.2501C14.3341 29.9968 15.1091 29.9968 16.6707 29.9968C18.2241 29.9968 19.0041 29.9968 19.6207 30.2501C20.4374 30.5884 21.0857 31.2368 21.4207 32.0501C21.6741 32.6634 21.6741 33.4401 21.6741 35.0001C21.6741 36.5601 21.6741 37.3334 21.4207 37.9501C21.0824 38.7668 20.4341 39.4151 19.6207 39.7501C19.0074 40.0034 18.2307 40.0034 16.6707 40.0034C15.1174 40.0034 14.3374 40.0034 13.7207 39.7501C12.9062 39.4119 12.259 38.7646 11.9207 37.9501C11.6674 37.3368 11.6674 36.5601 11.6674 35.0001ZM16.6674 38.3334C15.8674 38.3334 15.3524 38.3334 14.9507 38.3051C14.5707 38.2801 14.4257 38.2351 14.3574 38.2051C13.9495 38.0363 13.6252 37.7127 13.4557 37.3051C13.4274 37.2351 13.3824 37.0918 13.3557 36.7118C13.3291 36.3168 13.3291 35.8001 13.3291 34.9951C13.3291 34.1901 13.3291 33.6784 13.3574 33.2784C13.3824 32.8984 13.4274 32.7534 13.4557 32.6851C13.6249 32.2769 13.9492 31.9526 14.3574 31.7834C14.4274 31.7551 14.5707 31.7101 14.9507 31.6834C15.3457 31.6568 15.8624 31.6568 16.6674 31.6568C17.4674 31.6568 17.9824 31.6568 18.3841 31.6834C18.7641 31.7101 18.9091 31.7551 18.9774 31.7834C19.3853 31.9522 19.7095 32.2759 19.8791 32.6834C19.9074 32.7534 19.9524 32.8984 19.9791 33.2784C20.0057 33.6734 20.0057 34.1901 20.0057 34.9951C20.0057 35.8001 20.0057 36.3101 19.9774 36.7118C19.9524 37.0918 19.9074 37.2368 19.8791 37.3051C19.7095 37.7127 19.3853 38.0363 18.9774 38.2051C18.9074 38.2351 18.7641 38.2801 18.3841 38.3051C17.9891 38.3334 17.4724 38.3334 16.6674 38.3334Z" fill="#333"/>
                  <path d="M14.9987 5.83333C14.9987 5.61232 15.0865 5.40036 15.2428 5.24408C15.3991 5.0878 15.611 5 15.832 5H39.1654C39.3864 5 39.5983 5.0878 39.7546 5.24408C39.9109 5.40036 39.9987 5.61232 39.9987 5.83333C39.9987 6.05435 39.9109 6.26631 39.7546 6.42259C39.5983 6.57887 39.3864 6.66667 39.1654 6.66667H15.832C15.611 6.66667 15.3991 6.57887 15.2428 6.42259C15.0865 6.26631 14.9987 6.05435 14.9987 5.83333ZM4.16536 11.6667C4.38638 11.6667 4.59834 11.7545 4.75462 11.9107C4.9109 12.067 4.9987 12.279 4.9987 12.5V20H5.83203C6.05304 20 6.26501 20.0878 6.42129 20.2441C6.57757 20.4004 6.66536 20.6123 6.66536 20.8333C6.66536 21.0543 6.57757 21.2663 6.42129 21.4226C6.26501 21.5789 6.05304 21.6667 5.83203 21.6667H4.9987V34.1667C4.9987 34.3877 5.0865 34.5996 5.24278 34.7559C5.39906 34.9122 5.61102 35 5.83203 35C6.05304 35 6.26501 35.0878 6.42129 35.2441C6.57757 35.4004 6.66536 35.6123 6.66536 35.8333C6.66536 36.0543 6.57757 36.2663 6.42129 36.4226C6.26501 36.5789 6.05304 36.6667 5.83203 36.6667C5.16899 36.6667 4.53311 36.4033 4.06426 35.9344C3.59542 35.4656 3.33203 34.8297 3.33203 34.1667V12.5C3.33203 12.279 3.41983 12.067 3.57611 11.9107C3.73239 11.7545 3.94435 11.6667 4.16536 11.6667Z" fill="#333"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_1143_622">
                  <rect width="40" height="40" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>
              </Svg1>
            </ProductCountBadge>
            <CategoryIcon>
              <img src={category.image} alt={category.name} />
            </CategoryIcon>
            <BottomBox>
              <CategoryName>{category.name}</CategoryName>
              <CategoryView>View all</CategoryView>
            </BottomBox>
          </CategoryCard>
        ))}
      </CategoriesGrid>
    </Container>
  </PageWrapper>
);
};

export default AllCategoriesPage;